module.exports = __webpack_public_path__ + "static/media/Ananya.6d1dbbcb.jpg";